import React from 'react';
import LegalDocumentLayout from '../../components/legal/LegalDocumentLayout';
import { getLegalPage } from '../../content/legal/legalPages';

function RefundPolicyPage() {
  const page = getLegalPage('refund-policy');
  return <LegalDocumentLayout page={page} />;
}

export default RefundPolicyPage;
